import { Text, Texture } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { INewsItemOptions } from "./NewsItem";
import { NewsCurrencyComponent } from "../NewsCurrencyComponent";
import { NewsItemWithAvatar } from "./NewsItemWithAvatar";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { NewsRaidElementsToDowngrade } from "../../../../common/models/latestnews/NewsRaidElementsToDowngrade";

export class NewsItemRaidWithoutShield extends NewsItemWithAvatar {
    private static readonly RAIDED_TEXT = 'RAIDED YOUR BUILDING AND\nDAMAGED';
    private static readonly OF_YOUR_ITEMS_TEXT = 'OF YOUR ITEMS';

    private nameText: Text;
    private raidedText: Text;
    private ofYourItemsText: Text;
    private downgradedItems: NewsCurrencyComponent[];
    private commasForDowngradedItems: Text[];

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        options: NewsItemRaidWithoutShieldOptions
    ) {
        super(
            id,
            newsResources,
            userProfileResources,
            newsResources.assets_views_latest_news_news_tooltip_red_png,
            newsResources.assets_views_latest_news_news_raid_png,
            options.playerAvatarTexture
        );
        this.build(options);
        this.layout();
    }

    private build(options: NewsItemRaidWithoutShieldOptions): void {
        this.nameText = new Text(options.playerName, new NewsTextStyle());
        this.raidedText = new Text(NewsItemRaidWithoutShield.RAIDED_TEXT, new NewsTextStyle());
        this.createDowngradedItems(options.elementsToDowngrade);
        this.ofYourItemsText = new Text(NewsItemRaidWithoutShield.OF_YOUR_ITEMS_TEXT, new NewsTextStyle());
        this.avatar.updateTexture(options.playerAvatarTexture);

        this.addChild(this.nameText, this.raidedText, this.ofYourItemsText);
    }

    private createDowngradedItems(elementsToDowngrade: NewsRaidElementsToDowngrade[]): void {
        this.downgradedItems = [];
        this.commasForDowngradedItems = [];
        for (let i = 0; i < elementsToDowngrade.length; i++) {
            this.downgradedItems[i] = new NewsCurrencyComponent(
                this.newsResources,
                elementsToDowngrade[i].quantity,
                elementsToDowngrade[i].elementId
            );
            this.addChild(this.downgradedItems[i]);
            if ((i + 1) != elementsToDowngrade.length) {
                this.commasForDowngradedItems[i] = new Text(',', new NewsTextStyle());
                this.addChild(this.commasForDowngradedItems[i]);
            }
        }
    }

    private layout(): void {
        this.nameText.position.set(411, 29);
        this.raidedText.position.set(411, 72);
        this.layoutDowngradedItems();
        this.ofYourItemsText.position.set(411, 158);
    }

    private layoutDowngradedItems(): void {
        const elementsLength = this.downgradedItems.length;
        let commaNumber = 0;
        for (let i = 0; i < elementsLength; i++) {
            if (i == 0) {
                this.downgradedItems[i].position.set(523, 115);
            } else {
                this.downgradedItems[i].position.set(this.commasForDowngradedItems[commaNumber - 1].position.x + this.commasForDowngradedItems[commaNumber - 1].width, 115);
            }
            if ((i + 1) != elementsLength) {
                this.commasForDowngradedItems[commaNumber].position.set(this.downgradedItems[i].position.x + this.downgradedItems[i].width, 115);
                commaNumber++;
            }
        }
    }
}

export class NewsItemRaidWithoutShieldOptions implements INewsItemOptions {
    public readonly playerName: string;
    public readonly playerAvatarTexture: Texture;
    public readonly elementsToDowngrade: NewsRaidElementsToDowngrade[];

    public constructor(playerName: string, playerAvatarTexture: Texture, elementsToDowngrade: NewsRaidElementsToDowngrade[]) {
        this.playerName = playerName;
        this.playerAvatarTexture = playerAvatarTexture;
        this.elementsToDowngrade = elementsToDowngrade;
    }
}
